// The current UI language, without making this feature depend on being mounted
// inside TranslationProvider.
//
// `useTranslation` throws when there is no provider above it
// (contexts/TranslationContext.js:32). Inside the app there always is; in a
// unit test or a measurement harness that renders one section on its own there
// is not, and a thrown error there would say nothing about the section.
//
// So this reads the context itself, unconditionally, and falls back to English
// when it is empty. Catching the throw instead would have been a CONDITIONAL
// hook call, which React's rules-of-hooks rejects and the production build
// refuses to compile.
import { useContext } from "react";
import { TranslationContext } from "../../../contexts/TranslationContext";

export const useUiLanguage = () => {
  const context = useContext(TranslationContext);
  return (context && context.currentLanguage) || "en";
};

export default useUiLanguage;
